<template>
  <div class="tools_options folder_option">
    <div>
      <label>{{ $t("folder.save") }}</label>
    </div>
    <ValidationProvider>
      <el-select :disabled="disabled" :popper-append-to-body="false" class="select-primary" size="medium" clearable
        :placeholder="$t('generic.myDocuments')" v-model="folderId" @change="$emit('change', $event)">
        <!-- Create Folder -->
        <el-option class="select-primary" :label="$t('folder.create')" value="create_folder"></el-option>

        <el-option v-for="folder in folders" :key="folder.id" class="select-primary" :value="folder.id"
          :label="folder.name">
          <i class="fa-solid mr-1 fa-star"></i>
          <label>{{ folder.name }}</label>
        </el-option>
      </el-select>
    </ValidationProvider>

    <FolderCreateForm v-if="showForm" :key="componentKey" @hideForm="hideForm()" @folderCreated="setFolder" />
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import { mapGetters } from "vuex";
import FolderCreateForm from "@/pages/Pages/MyDocuments/FolderCreateForm.vue";

export default {
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    FolderCreateForm,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      folderId: "",
      showForm: false,
      componentKey: 0,
    };
  },
  computed: {
    ...mapGetters({
      folders: "getFolders",
    }),
  },
  watch: {
    folderId() {
      if (this.folderId === "create_folder") {
        this.showForm = true;
        this.folderId = "";
        this.$emit("change", this.folderId);
      } else {
        this.$emit("change", this.folderId);
      }
    },
    defaultfolder() {
      this.folderId = this.defaultfolder.id;
      this.$emit("change", this.folderId);
    },
  },
  methods: {
    hideForm() {
      this.showForm = false;
      this.formComponentKey++;
    },
    setFolder() {
      let newFolder = this.$store.state.folders.newFolder;
      this.folderId = newFolder.id;
    },
  },
  mounted() {
    this.$store.dispatch("fetchFolders");
  },
};
</script>

<style lang="scss">
.el-input__prefix {
  display: flex;
  align-items: center;
  left: 10px !important;
}
</style>
